import React, { useEffect, useRef } from "react";
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";

const RainBackground = () => {
  const mountRef = useRef(null);

  useEffect(() => {
    let scene, camera, renderer, controls;

    // Set up scene
    scene = new THREE.Scene();
    scene.background = new THREE.Color(0x524b4b); // Set background to red

    // Set up camera
    camera = new THREE.PerspectiveCamera(
      75, // Field of view
      window.innerWidth / (window.innerHeight * 2), // Aspect ratio
      0.1, // Near plane
      1000 // Far plane
    );
    camera.position.z = 5;

    // Set up renderer
    renderer = new THREE.WebGLRenderer({ antialias: true });
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setSize(window.innerWidth, window.innerHeight * 2); // Render for double height
    mountRef.current.appendChild(renderer.domElement);

    // Set up controls
    controls = new OrbitControls(camera, renderer.domElement);
    controls.enableDamping = true;
    controls.dampingFactor = 0.25;
    controls.screenSpacePanning = false;
    controls.maxPolarAngle = Math.PI / 2;

    // Rain particles
    const rainCount = 10000;
    const rainGeometry = new THREE.BufferGeometry();
    const positions = new Float32Array(rainCount * 3);

    for (let i = 0; i < rainCount; i++) {
      positions[i * 3] = Math.random() * 500 - 250;
      positions[i * 3 + 1] = Math.random() * 500 - 250;
      positions[i * 3 + 2] = Math.random() * 500 - 250;
    }

    rainGeometry.setAttribute(
      "position",
      new THREE.BufferAttribute(positions, 3)
    );
    const rainMaterial = new THREE.PointsMaterial({
      color: 0xaaaaaa,
      size: 0.1,
      transparent: true,
    });
    const rain = new THREE.Points(rainGeometry, rainMaterial);
    scene.add(rain);

    // Animation loop
    const animate = () => {
      requestAnimationFrame(animate);

      // Rain falling effect
      const positions = rain.geometry.attributes.position.array;
      for (let i = 1; i < positions.length; i += 3) {
        positions[i] -= 0.5;
        if (positions[i] < -250) positions[i] = 250; // Reset position
      }
      rain.geometry.attributes.position.needsUpdate = true;

      // Update controls
      controls.update();

      // Render the scene
      renderer.render(scene, camera);
    };

    animate();

    // Handle window resizing
    const onWindowResize = () => {
      camera.aspect = window.innerWidth / (window.innerHeight * 2);
      camera.updateProjectionMatrix();
      renderer.setSize(window.innerWidth, window.innerHeight * 2);
    };

    window.addEventListener("resize", onWindowResize);

    return () => {
      window.removeEventListener("resize", onWindowResize);
      renderer.dispose();
    };
  }, []);

  return (
    <div
      ref={mountRef}
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "130vh", // Set to 130% of viewport height
        overflow: "hidden",
        zIndex: "-100",
      }}
    />
  );
};

export default RainBackground;
